export default "__VITE_ASSET__CRVUIPw9__"